import { TextKeyValuePair } from '@/components/atomic/atoms';
import {
  ProductDescription,
  ProductDetails,
  ProductNotes,
  ProductPriceLabel
} from '@/components/atomic/molecules';
import { Divider } from '@/components/atomic/nuclei';
import { getSerializedRichText } from '@/helpers/editor';

const ProductSummaryDetailOrganism = ({ product }) => {
  const {
    description,
    displayAttributes,
    name,
    note,
    productPartners,
    shortDescription
  } = product;

  return (
    <div className='product-info w-full md:w-2/3 px-5 md:pr-20 md:pl-0'>
      <TextKeyValuePair
        {...{
          className: 'flex flex-col gap-4',
          label: name,
          labelClass: 'text-xl md:text-3xl font-semibold text-nero leading-6',
          value: shortDescription,
          valueClassName: 'text-brand text-sm md:text-base font-medium'
        }}
      />
      <div className='block md:hidden my-5'>
        <ProductPriceLabel {...{ productPartners }} />
      </div>
      <Divider />
      {getSerializedRichText(description) && (
        <ProductDescription {...{ description }} />
      )}
      {displayAttributes.length > 0 && (
        <ProductDetails {...{ displayAttributes }} />
      )}
      {getSerializedRichText(note) && <ProductNotes {...{ note }} />}
    </div>
  );
};

export default ProductSummaryDetailOrganism;
